<template>
  <div id="contenedor-agregar-catalogo-insumo">
    <v-form v-model="formularioValido" ref="formAgregarCatalogoInsumo">
      <v-card>
        <v-card-title class="secondary--text">
          Registrar nuevo insumo
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-text-field
            cols="12"
            label="Descripción"
            v-model="insumo.descripcion"
            :rules="[mixReglas.requerido]"
            required
          >
          </custom-text-field>
          <v-row>
          <custom-select
            cols="6"
            v-model="insumo.tipo"
            label="Tipo de Insumo"
            :items="itemsTiposInsumos"
            item-text="insumo"
            item-value="value"
            :rules="[mixReglas.requerido]"
            required>
          </custom-select>
          <custom-text-field
            cols="6"
            label="Orden"
            v-model.number="insumo.orden"
          >
          </custom-text-field>
          </v-row>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixAgregarCatalogoInsumo"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixCatalogoInsumos from './mixCatalogoInsumos';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'NuevoCatalogoInsumo',
  mixins: [mixCatalogoInsumos],
  components: {
    CustomTextField,
    CustomSelect,
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      itemsTiposInsumos: [
        { insumo: 'Personal', value: 1 },
        { insumo: 'Maquinaria', value: 2 },
        { insumo: 'Equipo', value: 3 },
      ],
      insumo: {
        tipo: 1,
        descripcion: '',
        orden: 0,
      },
    };
  },
  methods: {
    cerrar() {
      this.limpiarformulario();
      this.$emit('cerrar');
    },
    limpiarformulario() {
      this.$refs.formAgregarCatalogoInsumo.reset();
    },
  },

};
</script>

<style>

</style>
